app.config(function ($translateProvider) {
    $translateProvider.translations('nl', {
        REQUEST_ERROR: 'Er is iets mis gegaan, probeer het later nog eens',
        THIS_ENTITY_HAS_DEPENDENCIES: 'Record is in gebruik, niet mogelijk om te verwijderen.'
    });
});
